import {
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  Container,
  Grid,
  Box,
  Paper,
  Toolbar,
  ListItemText,
} from "@mui/material";
import { SyntheticEvent, useState } from "react";
import { StyledFormControl, menuStyles } from "../styled/StyledFormSelect";
import { Country } from "../../types/country";
import { useAppSelector } from "../../store/hooks";
import { selectCountries } from "../../store/selectors/countries";
import styles from "../../styles/Form.module.scss";
import { TableBar } from "../styled/AppBar";
import { selectQuestionnaires } from "../../store/selectors/questionnaireSelector";
import { StyledButton } from "../styled/Button";
import { handleApiError } from "../../utils/handleApiError";
import AlertDialog from "../Alert";
import { StyledCheckbox } from "../styled/StyledCheckbox";
import { exportRequestDB } from "../../services/api/questionnaires.api";

const StudentExportFormDB = ({ modal }: { modal?: () => void }) => {
  const questionnaires = useAppSelector(selectQuestionnaires)
    .map((questionnaire) => ({
      id: questionnaire._id,
      name: questionnaire.title.default,
    }))
    .sort((a, b) => a.id.localeCompare(b.id));
  // const [selectedQuestionnaire, setSelectedQuestionnaire] = useState("1");
  const [selectedQuestionnaires, setSelectedQuestionnaires] = useState<
    string[]
  >([]);
  const countries = useAppSelector(selectCountries);
  const [country, setCountry] = useState<Country>(countries[0]);
  const [error, setError] = useState<string | undefined>();
  const [alert, setAlert] = useState<string | undefined>();

  const idToNameMap = questionnaires.reduce((acc, q) => {
    acc[q.id] = q.name;
    return acc;
  }, {} as Record<string, string>);

  const changeQuestionnaire = (e: SelectChangeEvent<string[]>) => {
    const value = e.target.value as string[];
    setSelectedQuestionnaires(value);
  };

  const changeCountry = (e: SelectChangeEvent) => {
    console.log(e.target.value);
    const selected = countries.find(
      (country) => country._id === e.target.value
    );
    selected && setCountry(selected);
  };

  const handleSubmit = (event: SyntheticEvent) => {
    event.preventDefault();
    console.log("Submit");
    exportRequestDB(country.name, selectedQuestionnaires)
      .then((response) => {
        console.log(response);
        setAlert(response.data.data);
      })
      .catch((e) => {
        handleApiError(e, setError);
      });
  };

  return (
    <Container className={styles.formContainer} maxWidth='md'>
      <Paper elevation={2} className={styles.paper} sx={{ overflow: "hidden" }}>
        <TableBar position='relative'>
          <Toolbar
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <h2>{`Export Answered Parent Questionnaires to DB`}</h2>
          </Toolbar>
        </TableBar>
        <Box className={styles.box}>
          <form onSubmit={handleSubmit} autoComplete='off'>
            <Grid container rowSpacing={5} columnSpacing={3} pl={5} pr={5}>
              <Grid container item xs={12}>
                <StyledFormControl fullWidth>
                  <Select
                    multiple
                    labelId='pqs'
                    id='pqs'
                    value={selectedQuestionnaires}
                    onChange={(e) => {
                      changeQuestionnaire(e);
                    }}
                    // renderValue={(selected: string[]) => selected.join(", ")}
                    renderValue={(selected: string[]) =>
                      selected.length === 0
                        ? "Select Questionnaires to export..."
                        : selected.map((id) => idToNameMap[id]).join(", ")
                    }
                    displayEmpty
                    MenuProps={menuStyles}
                  >
                    {questionnaires.map((q) => (
                      <MenuItem key={q.id} value={q.id}>
                        <StyledCheckbox
                          checked={selectedQuestionnaires.indexOf(q.id) > -1}
                        />
                        <ListItemText primary={q.name} />
                      </MenuItem>
                    ))}
                  </Select>
                </StyledFormControl>
              </Grid>
              <Grid container item xs={12}>
                <StyledFormControl fullWidth>
                  <InputLabel id='select-country'>Country</InputLabel>
                  <Select
                    labelId='country'
                    id='country'
                    value={country._id}
                    label='Country'
                    onChange={(e) => changeCountry(e)}
                    size='small'
                  >
                    {countries.map((country, index) => (
                      <MenuItem key={index} value={country._id}>
                        {country.name}
                      </MenuItem>
                    ))}
                  </Select>
                </StyledFormControl>
              </Grid>
              <Grid container item xs={12} justifyContent={"center"}>
                <StyledButton
                  className={styles.button}
                  variant='contained'
                  type='submit'
                >
                  Export
                </StyledButton>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Paper>
      {(error || alert) && (
        <AlertDialog
          title={error ? "System Error" : "System Information"}
          message={error || alert || ""}
          buttons={[
            {
              label: "Ok",
              onClick: () => {
                error && setError(undefined);
                alert && setAlert(undefined);
                modal && modal();
              },
            },
          ]}
        />
      )}
    </Container>
  );
};

export default StudentExportFormDB;
